const store = {
    state() {
        return {
            countries: [],
            brandServices: [],
            defaultServices: [],
            zipCode: null,
            countryId: null,
            localityId: null,
            regionId: null,
            address: null,
            addressWarning: null,
            isFedexMethod: false,
        };
    },
    getters: {
        countries: state => state.countries,
        brandServices: state => state.brandServices,
        defaultServices: state => state.defaultServices,
        zipCode: state => state.zipCode,
        countryId: state => state.countryId,
        localityId: state => state.localityId,
        regionId: state => state.regionId,
        address: state => state.address,
        addressWarning: state => state.addressWarning,
        getIsFedexMethods: state => state.isFedexMethod,
    },
    mutations: {
        SET_COUNTRIES: (state, countries) => {
            state.countries = countries;
        },
        SET_BRAND_SERVICES: (state, brandServices) => {
            state.brandServices = brandServices;
        },
        UPDATE_FIELD(state, { field, value }) {
            state[field] = value;
        },
        SET_IS_FEDEX_METHODS: (state, value) => {
            state.isFedexMethod = value;
        },
        SET_DEFAULT_SERVICES: (state, services) => {
            state.defaultServices = services;
        },
    },
    actions: {
        async fetchDeliveryServices({ commit }) {
            try {
                const response = await this.$axios.$get('base/delivery-services/');

                if (response && response.length > 0) {
                    commit('SET_BRAND_SERVICES', response[0]?.brand_services);
                    commit('SET_COUNTRIES', response[0]?.countries);
                }
            } catch (e) {
                console.error(e);
            }
        },
    },
};

export default store;
